import { jsx as _jsx } from "react/jsx-runtime";
export default function Collapse({ open, id, labelledBy, children }) {
    return (_jsx("div", { id: id, className: `animated-collapse${open ? ' animated-collapse-open' : ''}`, role: "region", "aria-labelledby": labelledBy, "aria-hidden": !open, inert: !open, children: _jsx("div", { className: "animated-collapse-content", children: children }) }));
}
